module.exports = __webpack_public_path__ + "static/JAN-22-Amarin-Harris-Poll-Infographic-Understanding-The-Risks-19a1439f3e4f7ee39240edd35057c3d8.pdf";